import theme from '../../../lib/theme';
const { scale, corners, layouts, colors, font, media, layoutWidths } = theme;

export default () => ({
  teads: {
    backgroundColor: colors.light_grey,
    padding: `${scale.s} ${scale.xs}`,
    marginLeft: `-${scale.xs}`,
    marginRight: `-${scale.xs}`,
    borderRadius: 0,
    position: 'relative',

    '& > #outsourceTarget > iframe': {
      minWidth: 300,
      minHeight: 250,
    },

    [media.s.up]: {
      marginLeft: 0,
      marginRight: 0,
      borderRadius: corners.m,
    },
  },

  category: {
    textDecoration: 'none !important',

    '&:hover': {
      textDecoration: 'underline !important',
      color: `${colors.sas.primary} !important`,
    },
  },

  clouds: {
    marginBottom: `-${scale.xs}`,
  },

  cloud: {
    display: 'inline-block',
    marginRight: scale.xs,
    marginBottom: scale.xs,
    padding: scale.xxxs,
    backgroundColor: colors.light_grey,
    color: colors.sas.primary,
    borderRadius: corners.m,
    fontSize: font.s,
    fontWeight: font.bold,
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  bylineShares: {
    ...layouts.column,

    '& > *': {
      marginTop: scale.s,
    },

    '& > *:first-child': {
      marginTop: 0,
    },

    [media.s.up]: {
      ...layouts.row,

      justifyContent: 'space-between',

      '& > *': {
        marginLeft: scale.s,
        marginTop: 0,
      },

      '& > *:first-child': {
        marginLeft: 0,
      },
    },
  },

  cloudShares: {

    '& > *': {
      marginTop: scale.s,
    },

    '& > *:first-child': {
      marginTop: 0,
    },

    [media.s.up]: {

      alignItems: 'flex-start',
      justifyContent: 'space-between',

      '& > *': {
        marginLeft: scale.s,
        marginTop: 0,
      },

      '& > *:first-child': {
        marginLeft: 0,
      },
    },
  },

  lOnly: {
    [media.l.down]: {
      display: 'none !important',
    },
  },

  acquisitionPanel: {
    width: '100vw',
    margin: `${scale.m} -${scale.xs} ${scale.m}`,
  },

  adContainer : {
    padding: '21px 0',
    backgroundColor: '#f4f5f6',
  },

  gameContent: {
    marginLeft: '0',

    [media.xl.up]: {
      marginLeft: scale.m,
    },
  },

  gameIncontentWrapper: {
    [media.m.down]: {
      flexDirection: 'column !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',

      '> .Ad': {
        margin: '0 auto !important',
      },
    },
  },

  standardArticleContentWrap: {
    maxWidth: '100%',
    [media.l.up]: {
      maxWidth: layoutWidths.contentPane-layoutWidths.sidebar,
    },
  },
  linkbyContainer: { composes: '$standardArticleContentWrap', },
});
